import { render, staticRenderFns } from "./SelectPlate.vue?vue&type=template&id=5ebab350&scoped=true&"
import script from "./SelectPlate.vue?vue&type=script&lang=ts&"
export * from "./SelectPlate.vue?vue&type=script&lang=ts&"
import style0 from "./SelectPlate.vue?vue&type=style&index=0&id=5ebab350&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ebab350",
  null
  
)

export default component.exports